import { NotificationChannel, NotificationTopic } from './enums'

export const CHANNEL_LABELS: Record<
  NotificationChannel,
  { label: string; icon: string }
> = {
  [NotificationChannel.EMAIL]: { label: 'Email', icon: 'mail' },
  [NotificationChannel.PUSH]: { label: 'Notifications push', icon: 'bell' },
  [NotificationChannel.SMS]: { label: 'SMS', icon: 'smartphone' },
  [NotificationChannel.IN_APP]: {
    label: "Dans l'application",
    icon: 'app-window',
  },
  [NotificationChannel.INAPP]: {
    label: "Dans l'application",
    icon: 'app-window',
  },
}

export const TOPIC_LABELS: Record<
  NotificationTopic,
  { label: string; description: string } | undefined
> = {
  [NotificationTopic.SYSTEM]: {
    label: 'Système',
    description: 'Notifications importantes du système (sécurité, maintenance)',
  },
  [NotificationTopic.NEWSLETTER]: {
    label: 'Newsletter',
    description: 'Actualités et nouveautés de la plateforme',
  },
  [NotificationTopic.ACTIVITY]: {
    label: 'Activité',
    description: 'Nouvelles activités et exercices disponibles',
  },
  [NotificationTopic.MESSAGES]: {
    label: 'Messages',
    description: 'Nouveaux messages et conversations',
  },
  [NotificationTopic.GRADES]: {
    label: 'Notes',
    description: 'Nouvelles notes et évaluations',
  },
  [NotificationTopic.HOMEWORK]: {
    label: 'Devoirs',
    description: 'Nouveaux devoirs et rappels de dates limites',
  },
  [NotificationTopic.EVENTS]: {
    label: 'Événements',
    description: 'Événements et réunions à venir',
  },
  [NotificationTopic.REMINDERS]: {
    label: 'Rappels',
    description:
      'Rappels et résumés pédagogiques (ex. résumé hebdomadaire envoyé par e-mail)',
  },
  [NotificationTopic.CLASS]: {
    label: 'Classe',
    description: 'Notifications liées à la classe',
  },
  [NotificationTopic.ASSIGNMENT]: {
    label: 'Devoirs',
    description: 'Nouveaux devoirs et rendus',
  },
  [NotificationTopic.DEADLINES]: {
    label: 'Echéances',
    description: 'Rappels de dates limites',
  },
  [NotificationTopic.MARKETING]: {
    label: 'Marketing',
    description: 'Offres promotionnelles',
  },
}
